import validateURL from "../validate";

const isValidImageURL = (url: string) =>
  validateURL(url) &&
  /\.(jpeg|jpg|gif|png|bmp|svg|tiff)/.test(url) &&
  url.startsWith("https://");

export default isValidImageURL;
